import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CardGridSkeleton, QueryState, Segmented } from '@/components';
import { CourseCard } from '../CourseCard';
import { useCourses, useEnrollments } from '@/hooks/queries';
import type { CourseType } from '@/types/domain';

type Filter = 'all' | CourseType;

const FILTERS = [
  { value: 'all' as const, label: 'All' },
  { value: 'online' as const, label: 'Online' },
  { value: 'onsite' as const, label: 'Onsite' },
  { value: 'hybrid' as const, label: 'Hybrid' },
];

export function DesktopCatalog() {
  const navigate = useNavigate();
  const coursesQuery = useCourses();
  const { data: enrollments = [] } = useEnrollments();
  const [filter, setFilter] = useState<Filter>('all');

  const list = useMemo(
    () => (coursesQuery.data ?? []).filter((c) => c.status === 'active').filter((c) => filter === 'all' || c.type === filter),
    [coursesQuery.data, filter],
  );

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-.02em', margin: 0 }}>Course catalog</h1>
          <div className="th muted" style={{ fontSize: 14, marginTop: 4 }}>คอร์สเรียนทั้งหมด · {list.length} courses</div>
        </div>
        <Segmented value={filter} onChange={setFilter} size="sm" options={FILTERS} />
      </div>
      <QueryState
        query={coursesQuery}
        skeleton={<CardGridSkeleton count={6} cols={3} />}
        isEmpty={() => list.length === 0}
        emptyIcon="search"
        emptyTitle="No courses match"
        emptyHint="Try a different filter."
      >
        {() => (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 18 }}>
            {list.map((c) => (
              <CourseCard key={c.id} course={c} enrollment={enrollments.find((e) => e.courseId === c.id)} onClick={() => navigate(`/learn/catalog/${c.id}`)} />
            ))}
          </div>
        )}
      </QueryState>
    </div>
  );
}
